export enum ConfigNodeMenuId {
  SIDENAV = "SIDENAV",
  CENTRAL = "CENTRAL",
  APPBAR = "APPBAR"
}
